import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { BrowserRouter } from 'react-router-dom'
import { GoogleAnalyticsSpaTracker } from '@/components/analytics/GoogleAnalyticsSpaTracker'
import { GoogleTagsInit } from '@/components/analytics/GoogleTagsInit'
import { isTelegramAndroidWebView } from '@/lib/inAppBrowser'
import { App } from './app/App'
import './index.css'

const disableBootstrapAnalytics = isTelegramAndroidWebView()

const app = (
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        {!disableBootstrapAnalytics && <GoogleTagsInit />}
        {!disableBootstrapAnalytics && <GoogleAnalyticsSpaTracker />}
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>
)

const root = document.getElementById('root')!
if (root.hasChildNodes()) hydrateRoot(root, app)
else createRoot(root).render(app)
